import React from 'react';
import { LeafIcon, HomeIcon, GiftIcon, StoreIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { forYouItems } from '../data/forYou';
const icons = {
  leaf: LeafIcon,
  home: HomeIcon,
  gift: GiftIcon,
  store: StoreIcon
};
export function ForYou() {
  return <section className="w-full bg-cream px-5 py-16 sm:px-8 lg:py-24" data-id="element-53" data-mp="3bzpcfsoyzwgi">
      <div className="mx-auto max-w-6xl" data-id="element-54" data-mp="3qova3c85tema">
        <SectionHeading overline="Before you start" title={<>
              This guide is{' '}
              <span className="italic text-terracotta-500" data-id="element-56" data-mp="3lrv3n07ee9un">for you</span> if...
            </>} data-id="element-55" data-mp="3qnslxc281qa2" />

        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-57" data-mp="3ht72x582xwb">
          {forYouItems.map(item => {
          const Icon = icons[item.icon];
          return <li key={item.title} className="flex h-full flex-col rounded-3xl border border-gold-200/60 bg-bone p-6 transition-[transform,box-shadow] duration-200 ease-soft hover:-translate-y-1 hover:shadow-[0_20px_40px_-28px_rgba(56,52,44,0.55)]" data-id="element-58" data-mp="25bsh7f6lz97f">
                <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-sage-700 text-cream" data-id="element-59" data-mp="397bjhvzll6ow">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-60" data-mp="3e423gueiwmfl" />
                </span>
                <h3 className="mt-5 font-serif text-[1.35rem] font-medium leading-tight text-sage-800" data-id="element-61" data-mp="3iy699ac1yof3">
                  {item.title}
                </h3>
                <p className="mt-2.5 text-[14px] leading-relaxed text-ink-soft" data-id="element-62" data-mp="3rwrxnm47gxns">
                  {item.body}
                </p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}